<abp-modal
  class="userModal"
  [busy]="busy"
  [options]="{ size: 'xl' }"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
>
  <ng-template #abpHeader>
    <h3>
      {{ title | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <div class="row">
      @if (form) {
        <form [formGroup]="form" class="col-6" (ngSubmit)="onSaveClicked()" validateOnSubmit>
          <h4 class="mb-3">{{ 'AbpIdentity::UserInformations' | abpLocalization }}</h4>
          <div>
            <label class="form-label"
              >{{ 'AbpIdentity::Roles' | abpLocalization }}
              <span class="text-danger">*</span></label
            >
            @for (roleGroup of roleGroups; track trackByFn(i, roleGroup); let i = $index) {
              <div class="form-check mb-3">
                <input
                  type="radio"
                  class="form-check-input"
                  [id]="'roles-' + i"
                  (change)="onRoleClick($event, roles[i].name)"
                  [checked]="selectedRole === roles[i].name"
                />
                <label class="form-check-label" [attr.for]="'roles-' + i">{{
                  roles[i].name
                }}</label>
              </div>
            }
            @if (getFieldErrorMessage('roleNames')) {
              <div class="text-danger form-text">
                {{ getFieldErrorMessage('roleNames') }}
              </div>
            }
            @if (isManager) {
              <div class="form-check mb-3 py-3">
                <input
                  type="checkbox"
                  id="cost-centre-enabled"
                  class="form-check-input"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isCostCentre"
                />
                <label class="form-check-label" for="cost-centre-enabled">{{
                  'AdministrationService::CostCentreUser' | abpLocalization
                }}</label>
              </div>
            }
            <div class="mb-3">
              <label class="form-label" for="inspected-by">
                {{ 'ServicingService::Staff' | abpLocalization }}
              </label>
              <input
                id="inspected-by"
                [value]="staffUser ? staffUser.firstName + ' ' + staffUser.lastName : ''"
                class="form-control"
                maxlength="64"
                readonly
              />
            </div>
            <div class="mb-3">
              <label class="form-label">
                {{ 'ServicingService::Signature' | abpLocalization }}
              </label>
              <div class="picture-preview mx-auto">
                <div
                  [style.background-image]="
                    avatarUrl ? 'url(' + avatarUrl + ')' : 'url(assets/images/no-picture.jpg)'
                  "
                ></div>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label" for="user-name">
                {{ 'AbpIdentity::UserName' | abpLocalization }} <span class="text-danger">*</span>
              </label>
              <input
                id="user-name"
                type="text"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('userName')"
                formControlName="userName"
                autocomplete="username"
              />
              @if (getFieldErrorMessage('userName')) {
                <div class="text-danger form-text">
                  {{ getFieldErrorMessage('userName') }}
                </div>
              }
            </div>
            @if (!selected.id) {
              <div class="mb-3">
                <label class="form-label" for="password">
                  {{ 'AbpIdentity::Password' | abpLocalization }} <span class="text-danger">*</span>
                </label>
                <div class="input-group" validationTarget>
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    formControlName="password"
                    autocomplete="new-password"
                    [abpShowPassword]="showPassword()"
                  />
                  <button
                    class="btn btn-secondary"
                    type="button"
                    (click)="showPassword.set(!showPassword())"
                  >
                    <i
                      class="fa"
                      aria-hidden="true"
                      [class.fa-eye-slash]="!showPassword()"
                      [class.fa-eye]="showPassword()"
                    ></i>
                  </button>
                </div>
                @if (getFieldErrorMessage('password')) {
                  <div class="text-danger form-text">
                    {{ getFieldErrorMessage('password') }}
                  </div>
                }
              </div>
            }
            <div class="mb-3">
              <label class="form-label" for="name">
                {{ 'AbpIdentity::DisplayName:Name' | abpLocalization }}
                <span class="text-danger">*</span>
              </label>
              <input
                id="name"
                type="text"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('name')"
                formControlName="name"
              />
              @if (getFieldErrorMessage('name')) {
                <div class="text-danger form-text">
                  {{ getFieldErrorMessage('name') }}
                </div>
              }
            </div>
            <div class="mb-3">
              <label class="form-label" for="surname">
                {{ 'AbpIdentity::DisplayName:Surname' | abpLocalization }}
                <span class="text-danger">*</span>
              </label>
              <input
                id="surname"
                type="text"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('surname')"
                formControlName="surname"
              />
              @if (getFieldErrorMessage('surname')) {
                <div class="text-danger form-text">
                  {{ getFieldErrorMessage('surname') }}
                </div>
              }
            </div>
            <div class="mb-3">
              <label class="form-label" for="email">
                {{ 'AbpIdentity::EmailAddress' | abpLocalization }}
                <span class="text-danger">*</span>
              </label>
              <input
                id="email"
                type="email"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('email')"
                formControlName="email"
                autocomplete="email"
              />
              @if (getFieldErrorMessage('email')) {
                <div class="text-danger form-text">
                  {{ getFieldErrorMessage('email') }}
                </div>
              }
            </div>
            <div class="mb-3">
              <label class="form-label" for="phone-number">
                {{ 'AbpIdentity::PhoneNumber' | abpLocalization }}
              </label>
              <input
                id="phone-number"
                type="text"
                class="form-control"
                [class.is-invalid]="isFieldInvalid('phoneNumber')"
                formControlName="phoneNumber"
                autocomplete="tel"
              />
              @if (getFieldErrorMessage('phoneNumber')) {
                <div class="text-danger form-text">
                  {{ getFieldErrorMessage('phoneNumber') }}
                </div>
              }
            </div>
            <div class="mb-3">
              <label class="form-label" for="pin">
                {{ 'IdentityService::Pin' | abpLocalization }}
              </label>
              <div class="input-group">
                <input
                  id="pin"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="pin !== '' && !isPinValid"
                  inputmode="numeric"
                  pattern="[0-9]{4}"
                  maxlength="4"
                  [ngModel]="pin"
                  (ngModelChange)="onPinInput($event)"
                  [ngModelOptions]="{ standalone: true }"
                  autocomplete="off"
                />
                <button class="btn btn-secondary" type="button" (click)="generatePin()">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
              @if (selected.id && isPinValid) {
                <div class="form-text">
                  {{ 'IdentityService::LeaveBlank' | abpLocalization }}
                </div>
              }
              @if (pin !== '' && !isPinValid) {
                <div class="text-danger form-text">PIN must be exactly 4 digits.</div>
              }
            </div>
            <div class="mb-3">
              <label class="form-label" for="keyring-password">
                {{ 'IdentityService::KeyringPassword' | abpLocalization }}
              </label>
              <div class="input-group">
                <input
                  id="keyring-password"
                  type="text"
                  class="form-control"
                  [(ngModel)]="keyringPassword"
                  [ngModelOptions]="{ standalone: true }"
                  autocomplete="off"
                />
                <button class="btn btn-secondary" type="button" (click)="generateKeyringPassword()">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
              @if (selected.id) {
                <div class="form-text">
                  {{ 'IdentityService::LeaveBlank' | abpLocalization }}
                </div>
              }
              @if (qrImageSrc) {
                <img [src]="qrImageSrc" class="mt-2" style="max-width: 120px" />
              }
            </div>
            <div class="form-check mb-2">
              <input
                id="active-checkbox"
                type="checkbox"
                class="form-check-input"
                formControlName="isActive"
              />
              <label class="form-check-label" for="active-checkbox">
                {{ 'AbpIdentity::DisplayName:IsActive' | abpLocalization }}
              </label>
            </div>
            @if (!selected.id) {
              <div class="form-check mb-2">
                <input
                  id="should-change-password-on-next-login"
                  type="checkbox"
                  class="form-check-input"
                  formControlName="shouldChangePasswordOnNextLogin"
                />
                <label class="form-check-label" for="should-change-password-on-next-login">
                  {{ 'AbpIdentity::DisplayName:ShouldChangePasswordOnNextLogin' | abpLocalization }}
                </label>
              </div>
            }
            <div class="form-check mb-3">
              <input
                id="lockout-checkbox"
                type="checkbox"
                class="form-check-input"
                formControlName="lockoutEnabled"
              />
              <label class="form-check-label" for="lockout-checkbox">
                {{ 'AbpIdentity::DisplayName:LockoutEnabled' | abpLocalization }}
              </label>
            </div>
            <div class="col-12 col-sm-3">
              <div class="flex flex-col mb-3">
                <label class="form-label" for="asset-hours">
                  {{ 'RegisterService::Notifications' | abpLocalization }}
                </label>
                <div class="flex gap-1">
                  @for (key of notificationOptions; track key) {
                    <div class="flex items-center gap-1">
                      <input
                        type="checkbox"
                        [id]="'note-' + key"
                        class="form-check-input"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="notificationSettings[key]"
                      />
                      <label [for]="'note-' + key" role="button" class="me-2 min-w-max">
                        {{ 'RegisterService::' + capitalizeFirstLetter(key) | abpLocalization }}
                      </label>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div>
              <label class="form-label">{{
                'AbpIdentity::OrganizationUnits' | abpLocalization
              }}</label>
              @if (organization.nodes?.length) {
                <abp-tree
                  [checkStrictly]="true"
                  [checkable]="true"
                  [nodes]="organization.nodes"
                  [isNodeSelected]="organization.selectFn"
                  [(checkedKeys)]="organization.checkedKeys"
                  [(expandedKeys)]="organization.expandedKeys"
                >
                </abp-tree>
              } @else {
                <p class="text-muted">
                  {{ 'AbpIdentity::NoOrganizationUnits' | abpLocalization }}
                </p>
              }
            </div>
          </div>
        </form>
      }
      <div class="col">
        <div class="row mb-3">
          <h5>
            {{
              (isCostCentre ? 'RegisterService::CostCentre' : 'RegisterService::Locations')
                | abpLocalization
            }}
          </h5>
          @if (isCostCentre) {
            <app-cost-centre-tree
              [isLoading]="busy || costCentresLoading"
              [data]="costCentres"
              [readonly]="true"
              [checkable]="true"
              [checkStrictly]="true"
              [showSelectAll]="true"
              [(checkedKeys)]="checkedKeys"
            />
          } @else {
            <app-locations
              [isLoading]="busy"
              [readonly]="true"
              [checkable]="true"
              [homeTopLevelOnly]="true"
              [getAll]="true"
              [includeInactive]="true"
              [hideSelect]="true"
              [checkStrictly]="false"
              [isAllSelected]="true"
              [showSelectAll]="true"
              [(restrictedKeys)]="restrictedKeys"
              [(allowedKeys)]="allowedKeys"
              [(selectedLocation)]="selectedLocation"
            >
            </app-locations>
          }
        </div>
        <div class="row pt-1">
          <app-event-types [(restrictedKeys)]="restrictedEvents" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </button>
    <abp-button
      iconClass="fa fa-check"
      (click)="onSaveClicked()"
      [disabled]="form?.invalid || !isPinValid"
      >{{ 'AbpUi::Save' | abpLocalization }}</abp-button
    >
  </ng-template>
</abp-modal>
